// The AlphaLab panel (design-revamp.md section 8): AlphaLab beside the chat on a wide screen, in all
// the width the chat leaves, closed with X or Escape. The frame may never navigate Quanty One (no allow-top-navigation).
import { ExternalLink, X } from "lucide-react";
import { useEffect } from "react";
import { Button } from "./ui/button.js";

export interface PanelState {
  url: string;
  title?: string;
}

export function Panel({ state, onClose }: { state: PanelState; onClose(): void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <aside className="flex h-full min-w-0 flex-1 flex-col border-l border-border bg-card" aria-label="AlphaLab">
      <div className="flex h-10 shrink-0 items-center gap-2 border-b border-border px-3">
        <span className="min-w-0 flex-1 truncate text-sm font-medium">{state.title ?? "AlphaLab"}</span>
        <Button asChild variant="ghost" size="icon-sm" aria-label="Open in new tab">
          <a href={state.url} target="_blank" rel="noopener noreferrer">
            <ExternalLink />
          </a>
        </Button>
        <Button variant="ghost" size="icon-sm" aria-label="Close AlphaLab" onClick={onClose}>
          <X />
        </Button>
      </div>
      <iframe
        key={state.url}
        src={state.url}
        title={state.title ?? "AlphaLab"}
        className="min-h-0 w-full flex-1 border-0 bg-background"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </aside>
  );
}
